export default "__VITE_ASSET__CesAFJ4i__"